<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#3F033B"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-layout wrap>
      <v-flex xs12 text-left pb-2>
        <span class="mainHeader">AUDIT LOG</span>
      </v-flex>
      <v-flex xs12 py-6 text-left>
        <v-card class="rounded-lg" elevation="0" color="#FFFFFF">
          <v-layout wrap pa-4 v-if="logList.length > 0">
            <v-flex xs12>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Date</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>User</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Action</b></th>
                      <th class="text-left tablefont" style="font-size: 15px; color: black"><b>Details</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, i) in logList" :key="i" class="table">
                      <td>{{ formatDate(value.create_date) }}</td>
                      <td>
                        <span v-if="value.userId">{{ value.userId.firstname }} {{ value.userId.lastname }}</span>
                        <span v-else>—</span>
                      </td>
                      <td>{{ value.action }}</td>
                      <td>
                        <span v-if="value.note">{{ value.note }}</span>
                        <span v-else-if="value.changes && Object.keys(value.changes).length">
                          <span v-for="(change, field) in value.changes" :key="field">
                            {{ field }}: {{ change.old }} → {{ change.new }}<br />
                          </span>
                        </span>
                        <span v-else>—</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-flex>
            <v-flex xs12 text-center pt-4 v-if="Pagelength > 1">
              <v-pagination v-model="page" :length="Pagelength" @input="getAuditLog"></v-pagination>
            </v-flex>
          </v-layout>
          <v-layout wrap pa-4 v-else>
            <v-flex xs12 text-center>No audit log entries yet.</v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      logList: [],
      page: 1,
      Pagelength: null,
    };
  },
  mounted() {
    this.getAuditLog();
  },
  methods: {
    getAuditLog() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/auditlog/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: this.page,
          limit: 25,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.logList = response.data.data;
            this.Pagelength = Math.ceil(response.data.totalCount / 25);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    formatDate(date) {
      if (!date) return "—";
      var d = new Date(date);
      return d.toLocaleString();
    },
  },
};
</script>
